/**
 * Join a first and last name into a display name, tolerating missing parts.
 * Returns "" when both are absent so callers can fall back (e.g. to email).
 */
export const getUserFullName = (
  firstName?: string | null,
  lastName?: string | null,
): string => `${firstName ?? ""} ${lastName ?? ""}`.trim();
